import React from 'react';

export default function usePrevious(queryParams) {
  const ref = React.useRef();

  React.useEffect(() => {
    ref.current = queryParams;
  });

  return ref.current;
}
